import { Callout, H5, P, TextButton, lightTheme } from '@vgrubs/components';
import { Fragment } from 'react';
import {
  PlaybookBlock,
  PlaybookLink,
  PlaybookSection,
} from '../playbookContent';
import { TimingTable } from './TimingTable';
import {
  BlockStack,
  BulletList,
  LinkRow,
  SectionCard,
  SectionImage,
  StepList,
} from './PlaybookSectionCard.styled';

type Props = {
  section: PlaybookSection;
  onOpenLink: (link: PlaybookLink) => void;
};

const renderBlock = (block: PlaybookBlock, onOpenLink: Props['onOpenLink']) => {
  switch (block.kind) {
    case 'text':
      return <P $m="0">{block.text}</P>;
    case 'bullets':
      return (
        <BulletList>
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </BulletList>
      );
    case 'steps':
      return (
        <StepList>
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </StepList>
      );
    case 'callout':
      return <Callout tone={block.tone}>{block.text}</Callout>;
    case 'image':
      return <SectionImage src={block.src} alt={block.alt} />;
    case 'timings':
      return <TimingTable rows={block.rows} />;
    case 'links':
      return (
        <LinkRow>
          {block.links.map((link) => (
            <TextButton
              key={link.label}
              $underline
              color={lightTheme.primary}
              onClick={() => onOpenLink(link)}
            >
              {link.label}
            </TextButton>
          ))}
        </LinkRow>
      );
    default:
      // Exhaustive: a new block kind has to be rendered here.
      return null;
  }
};

export const PlaybookSectionCard = ({ section, onOpenLink }: Props) => (
  <SectionCard>
    <H5 $m="0 0 12px">{section.title}</H5>
    <BlockStack>
      {section.blocks.map((block, index) => (
        <Fragment key={index}>{renderBlock(block, onOpenLink)}</Fragment>
      ))}
    </BlockStack>
  </SectionCard>
);
